import React from 'react';
import ReactTooltip from 'react-tooltip';
import { ConfirmButton } from '../../../styling/Styles';
import { TitleCard,
        SecurityLabel,
        ValueSection
} from './MetricsHelpfullComponents';

const SecurityCard = (props) => {

    const{
        metricsData
    }=props;

    const title = 'Security Vulnerabilities of Dependencies';
    const tooltipMessage = 'It identifies the known vulnerabilities <br/> existing in  the dependencies of the source <br/> code.'

    return(
        <div style={{width: '28%'}} >
            <TitleCard title ={title} tooltipMessage={tooltipMessage} />
            <div style={{padding: '1rem',border: 'solid',borderWidth: '0px', borderBottomLeftRadius: '0.5rem', borderBottomRightRadius: '0.5rem', boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)'}}>
                <ValueSection score={metricsData !== undefined ? metricsData.metricsScores.security.NSP_VIOL.avgScore : 0} value ={metricsData !== undefined ? metricsData.HighLevelMetrics.DependenciesVulnerabilities : '-'} />        
                <div style={{display: 'flex', flexDirection: 'column', marginTop: '2.5rem'}}>
                    <span style={{display: 'flex', justifyContent: 'center'}}> Consider changing or upgrading your</span>
                    <span style={{display: 'flex', justifyContent: 'center'}}> dependencies into later versions.</span>
                </div>
                <div style={{display: 'flex', marginTop: '2rem', justifyContent: 'center'}}>
                    <div style={{width: '30%'}}><ConfirmButton>MORE INFO</ConfirmButton></div>
                </div>
                <div style={{display: 'flex', justifyContent: 'end', marginTop: '2rem'}}>
                    <SecurityLabel/>
                    <ReactTooltip place='left' effect='solid' />
                </div>
            </div>
        </div>
    )
}

export default SecurityCard;